import type { CSS } from '@stitches/react';
import { styled } from '../../../stitches.config';

export const InvalidMessage = styled('div', {
  color: '$skin-red',
  fontSize: '$xs',
  paddingTop: '$spacing-1x',
});

export const Label = styled('label', {
  display: 'block',
  fontSize: '$xs',
  fontWeight: '$bold',
  paddingBottom: '$spacing-1x',
});

const disableInputStyles: CSS = {
  appearance: 'none',
  backgroundColor: 'transparent',
  border: 'none',
  borderRadius: 0,
};

const inputStyles: CSS = {
  boxShadow: '$shadow-3',
  font: 'inherit',
  padding: '$spacing-1x $spacing-2x',
  width: '100%',
};

export const TextboxMultiline = styled('textarea', {
  ...disableInputStyles,
  ...inputStyles,
  maxWidth: '100%',
  minHeight: '7.5em',
  minWidth: '100%',
  variants: {
    validation: {
      invalid: {
        border: '1px solid $skin-red',
      },
    },
  },
});

export const TextboxSingleline = styled('input', {
  ...disableInputStyles,
  ...inputStyles,
  variants: {
    validation: {
      invalid: {
        border: '1px solid $skin-red',
      },
    },
  },
});
